import { EnvironmentEnum } from '../../../environments/environment.interface';

export const getEnvType: () => EnvironmentEnum = () => window.location.href.includes('requests.vista.studio') ? EnvironmentEnum.PRODUCTION : EnvironmentEnum.DEVELOPMENT;
